import { useRef } from "react";

/**
 * sets a value that expires after a certain amount of time.
 *
 * Example use case is
 * i want to ignore all focus events within 100 ms of a value changing.
 */
export function useValueTimeout<T>(ms: number) {
  const idRef = useRef<any>(null);
  const blockRef = useRef<T | undefined>(undefined);
  function setValue(value: T) {
    if (idRef.current) {
      clearTimeout(idRef.current);
    }
    blockRef.current = value;
    setTimeout(() => {
      blockRef.current = undefined;
    }, ms);
  }
  return { getDisplayValue: () => blockRef.current, setValue };
}
